import { Link } from "gatsby"
import { FC } from "react"
import classNames from "classnames"

// components
import {
  findIcon,
  icons,
  iconsSizedForCatSideNav
} from "../../components/BrowseByTopicSection/Topic"

// styles
import {
  categorySideNavWrapper,
  selected,
  iconWrapper,
  header,
  categoryLinks
} from "./CategorySideNav.module.scss"
import { handleUrlString } from "../../utils/seo/seo_utils"

export type FeaturedCategoryItem = {
  categoryMenuSlug: string
  categoryTitle: string
  iconName: string
  audienceName: string
}

export type Props = {
  featuredCategoriesList: FeaturedCategoryItem[]
  featuredCategoriesTitle: string
  prefixedBasePath: string
  selectedCategory?: string
}

const CategorySideNav: FC<Props> = ({
  featuredCategoriesTitle,
  featuredCategoriesList,
  selectedCategory,
  prefixedBasePath
}) => {
  return (
    <div className={categorySideNavWrapper}>
      <h2 className={header}>{featuredCategoriesTitle}</h2>
      <ul>
        {featuredCategoriesList?.map((cat) => (
          <li key={cat?.categoryTitle}>
            <div className={iconWrapper}>
              {findIcon(cat?.iconName, iconsSizedForCatSideNav)}
            </div>
            <Link
              className={classNames(categoryLinks, {
                [`${selected}`]: selectedCategory === cat?.categoryTitle
              })}
              to={handleUrlString(
                `${prefixedBasePath}/topics/${cat?.categoryMenuSlug}`,
                { removePrefix: true }
              )}
            >
              {cat?.categoryTitle}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CategorySideNav